import React from 'react'
import {
  Box,
  Button,
  Container,
  Typography,
  useTheme,
} from '@mui/material'
import { useHandleChangeRoute } from 'data/hooks'
import DemoVideo from 'static/videos/Demo3.mp4'

const VideoShowcase = () => {
  const theme = useTheme()
  const handleChangeRoute = useHandleChangeRoute()

  return (
    <Box sx={{ py: { xs: 6, md: 8 }, backgroundColor: theme.palette.grey[50] }}>
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center', mb: { xs: 3, md: 4 } }}>
          <Typography
            variant="overline"
            sx={{
              color: theme.palette.primary.dark,
              fontWeight: 600,
              letterSpacing: '0.1em',
              fontSize: '0.9rem',
              display: 'block',
              mb: 1,
            }}
          >
            SEE MYSTETHI IN ACTION
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.grey[600],
              fontSize: '1.05rem',
              lineHeight: 1.7,
              maxWidth: '600px',
              mx: 'auto',
            }}
          >
            Founded by medical providers who experienced the frustrations of job searching firsthand — we built something better.
          </Typography>
        </Box>

        <Box
          sx={{
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: theme.palette.shadows.heavy,
          }}
        >
          <Box
            component="video"
            src={DemoVideo}
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            title="MyStethi AI-powered job search demonstration"
            sx={{
              width: '100%',
              display: 'block',
            }}
            onError={(e) => console.error('Video failed to load:', e)}
          />
        </Box>

        <Box sx={{ textAlign: 'center', mt: { xs: 4, md: 5 } }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => handleChangeRoute('/register/physicians')()}
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              fontWeight: 600,
              px: 5,
              py: 1.75,
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '1rem',
              boxShadow: theme.palette.shadows.colored.primary,
              '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                boxShadow: theme.palette.shadows.colored.primaryHover,
                transform: 'translateY(-2px)',
              },
            }}
          >
            Get Started
          </Button>
        </Box>
      </Container>
    </Box>
  )
}

export default VideoShowcase
